import { TABLES } from '@/utils/constants';
import { getAllRecords, getRecord } from '@/utils/helpers/data';
import { CLINIC_COLUMNS, Clinic } from '@/utils/schema';

export type { Clinic };
export const COLUMNS = CLINIC_COLUMNS;

/**
 * Retrieves a single clinic by its ID.
 * @param clinicId - The ID of the clinic to retrieve.
 * @returns The requested clinic or null if not found.
 * @throws Will throw an error if the retrieval fails.
 */
export const getClinic = async (
  clinicId: string | null | undefined
): Promise<Clinic | null> => {
  if (!clinicId) return null;
  return getRecord<Clinic>(TABLES.CLINICS, COLUMNS.ID, clinicId);
};

/**
 * Retrieves all clinics from the database.
 * @returns An array of all clinics.
 * @throws Will throw an error if the retrieval fails.
 */
export const getAllClinics = async (): Promise<Clinic[]> => {
  return getAllRecords<Clinic>(TABLES.CLINICS);
};
